module.exports = __webpack_public_path__ + "static/media/logo_horizontal.9af9da8b.png";